export default {
      id: "common__info-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.svg#common__info",
      toString: function () {
        return this.url;
      }
    }